export default __webpack_public_path__ + "static/Countries-92d084f07a30f4f21698ee52795ec0fd.png";